import {Link} from "react-router-dom";
import styled from "styled-components";
import {Steps} from "antd";

export const Container = styled.div``;

export const TrialStepContainer = styled.div`
    border-left: 1px solid ${({iscompleted}) => (iscompleted === "true" ? "#1890ff" : "#f0f0f0")};
    margin-left: 3px;
`;

export const TrialStep = styled(Steps.Step)`
    padding-left: 20px !important;
    .ant-steps-item-tail {
        &:after {
            display: none;
        }
    }
`;

export const TrialTitle = styled.div`
    color: ${({iscompleted}) =>
        iscompleted === "true" ? "rgba(0, 0, 0, 0.85)" : "rgba(0, 0, 0, 0.45)"};
`;
